






























// Import vendors ----------------------------------------------------------------------------------
import { ref, computed, defineComponent } from '@vue/composition-api';
// Import utils ------------------------------------------------------------------------------------
import { useFormObserver, useFormFieldText } from '@/utils/forms.utils';
// Import components -------------------------------------------------------------------------------
import AuthWrapper from '@/components/auth/AuthWrapper.vue';
import FormFieldPassword from '@/components/forms/FormFieldPassword.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'AuthSignInChallengeNewPasswordRequired',
  components: { AuthWrapper, FormFieldPassword },
  props: {
    signInService: {
      type: Object,
      required: true
    }
  },
  setup(properties) {
    const rAuthWrapper = ref(null);

    const observer = useFormObserver();

    const password = useFormFieldText<string>({
      key: 'password',
      type: 'password',
      value: '',
      rules: {
        required: true,
        password: true
      }
    });

    function submit() {
      properties.signInService.send({
        type: 'RESOLVE_CHALLENGE_NEW_PASSWORD_REQUIRED',
        data: {
          password: password.value
        }
      });
    }

    const isErrored = computed(() =>
      [{ challenged: { newPasswordRequired: 'failure' } }].some((element) =>
        properties.signInService.state.value.matches(element)
      )
    );

    const isDisabled = computed(() =>
      [{ challenged: { newPasswordRequired: 'processing' } }, 'success'].some((element) =>
        properties.signInService.state.value.matches(element)
      )
    );

    const isLoading = computed(() =>
      [{ challenged: { newPasswordRequired: 'processing' } }].some((element) =>
        properties.signInService.state.value.matches(element)
      )
    );

    return {
      // References
      rAuthWrapper,
      // Form observer
      observer,
      // Form fields
      password,
      // Actions
      submit,
      // Flags
      isErrored,
      isDisabled,
      isLoading
    };
  }
});
